// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".one-column[data-v-1b61b690]{display:flex;flex-direction:column;align-items:center}.one-column img[data-v-1b61b690]{margin-bottom:2px}.two-columns[data-v-1b61b690]{display:grid;grid-template-columns:repeat(2,1fr);gap:5px}.two-columns .image-wrapper img[data-v-1b61b690]{margin-bottom:0;cursor:pointer}@media (max-width:800px){.two-columns[data-v-1b61b690]{gap:2px}}.image-wrapper img[data-v-1b61b690]{max-width:100%;height:auto;display:block}img[data-v-1b61b690]{border-radius:2px}", ""]);
// Exports
module.exports = exports;
